const socialAccounts = [
  { value: "Linkedin", label: "Linkedin" },
  { value: "Behance", label: "Behance" },
  { value: "Twitter", label: "Twitter" },
  { value: "Github", label: "Github" },
];

export default socialAccounts;
